import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';
import { useOnboardingDetails } from './data/OnboardingAPI';
import { OnboardingStep } from './data/OnboardingDTO';
import { useDispatcherProfile } from '../dispatcher/DispatcherAPI';

// steps by priority
const ONBOARDING_STEPS_PATH = {
  welcome_to_ctms: '/onboarding',
  question_how_can_ctms_make_your_job_easier: '/onboarding/questions-step-1',
  team_invitation: '/onboarding/invite-team',
};
type OnboardingStepName = keyof typeof ONBOARDING_STEPS_PATH;

function getLastPendingStepName(steps: OnboardingStep['steps']) {
  for (const step of Object.keys(
    ONBOARDING_STEPS_PATH,
  ) as OnboardingStepName[]) {
    if (steps?.[step]?.status === 'pending') {
      return step;
    }
  }
  return null;
}

export function useStartOnboarding() {
  const navigate = useNavigate();
  const isWebview = MobileAppBridge.isInjected();
  const { data: dispatcher } = useDispatcherProfile();
  const guid = dispatcher?.guid;

  const { data: onboarding, isInitialLoading } = useOnboardingDetails({
    enabled: !isWebview && !!guid,
  });

  useEffect(() => {
    if (!onboarding?.steps) return;

    const lastPendingStepName = getLastPendingStepName(onboarding.steps);

    if (lastPendingStepName) {
      navigate(ONBOARDING_STEPS_PATH[lastPendingStepName]);
    }
  }, [onboarding?.steps, navigate]);

  return { isInitialLoading, onboarding };
}
